import { render, staticRenderFns } from "./InlineCommentSelectionPopover.vue?vue&type=template&id=65a497a5"
import script from "./InlineCommentSelectionPopover.js?vue&type=script&lang=js&external"
export * from "./InlineCommentSelectionPopover.js?vue&type=script&lang=js&external"
import style0 from "./InlineCommentSelectionPopover.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports